import { debounce } from "lodash";
import { registerScrollDetectEvent } from "./scroll-detect";
import { getOffsetTop } from "./utils/layout";

declare const jQuery: any;
const $ = jQuery;

export function initRiseUpFallDown(): void
{
	const $divs = $(".rise-up,.fall-down,.slide-right,.slide-left");

	if ($divs.length === 0)
	{
		return;
	}

	const $window = $(window);
	
	$divs.each(function () {
		const $div = $(this);
		
		function getThreshold(): number
		{
			const viewportHeight = $window.outerHeight();
			const divTop = getOffsetTop($div);
			return (divTop - viewportHeight);
		}

		function onPassForward(): void
		{
			$div.removeClass("hidden");
		}

		function onPassBackward(): void
		{
			$div.addClass("hidden");
		}

		onPassBackward();

		const forceTrigger = registerScrollDetectEvent(onPassForward, onPassBackward, getThreshold);

		$window.on("scroll", debounce(forceTrigger, 300));
	});
}
